import { z } from 'zod';

const MIN_PORT = 1;
const MAX_PORT = 65535;

export const INVALID_PORT_ERR = 'Invalid port(s)';
export const MIN_PORT_ERR = 'Port must be > 0';
export const MAX_PORT_ERR = 'Port cannot exceed 65535';
export const ORDER_ERR = 'End must be > start';

// TODO: add error messages.  Use ports-field/validatePorts.ts as guide
// TODO: should be a string that parses to an object
// Allow "0", "any",
// Refer to parsePorts.ts

export const portRangeSchema = z
  .object({
    from: z.number({ invalid_type_error: INVALID_PORT_ERR }).int(),
    to: z.number({ invalid_type_error: INVALID_PORT_ERR }).int(),
  })
  .superRefine((arg, ctx) => {
    if (arg.from > arg.to) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: ORDER_ERR,
        fatal: true,
      });

      return z.NEVER;
    }

    if (arg.from < MIN_PORT || arg.to < MIN_PORT) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: MIN_PORT_ERR,
        fatal: true,
      });

      return z.NEVER;
    }

    if (arg.from > MAX_PORT || arg.to > MAX_PORT) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: MAX_PORT_ERR,
        fatal: true,
      });

      return z.NEVER;
    }

    return z.NEVER;
  })
  .or(z.null());
